import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import {
  spacing12,
  spacing16,
  spacing24,
  spacing4,
} from 'approot/shared/styles/spacing.style';
import { TabsStyled, TabsTabStyled } from 'approot/shared/tabs/tabs.style';
import {
  SubActivityInstruction,
  SubActivityLabel,
} from '../components/sub-activity/sub-activity-view.style';
import {
  fontSize20,
  fontSize20LineHeight,
  fontSize24,
  fontSize30,
  fontSize30LineHeight,
  fontWeightNormal,
} from 'approot/shared/styles/typography.style';
import { azure7, grey1, grey5 } from 'approot/shared/styles/colours.style';
import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';
import { ResponseFieldReadonly } from '../components/response/response-field-readonly.style';
import {
  borderRadius8,
  standardFocusStateInset,
} from 'approot/shared/styles/borders.style';
import { BoxList } from 'approot/shared/design-system/box/box.style';
import { ACTIVITY_SHEET_CONTENT_MAX_WIDTH } from '../components/shared/sheet/activity-sheet.style';
import { flexSpaceBetweenCss } from 'approot/shared/styles/flex.style';

export const ClassroomAnswerTabs = styled.div`
  ${flexSpaceBetweenCss}
  background-color: ${grey1};
  border-bottom: 1px solid ${grey5};
  padding: 0 ${rem(spacing24)};

  ${TabsStyled} {
    display: block;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    flex: 1;
  }

  ${TabsTabStyled} {
    margin-right: ${rem(spacing16)};
  }

  ${mediaUp.md`
    ${TabsStyled} {
      display: block;
      max-width: 100%;
    }

    ${TabsTabStyled} {
      font-size: ${rem(fontSize24)};
      margin-right: ${rem(spacing24)};
      padding-top: ${rem(spacing24)};
      padding-bottom: ${rem(spacing24)};
    }
  `}
`;

type ClassroomAnswerInstructionProps = {
  $noMarginBottom?: boolean;
};
export const ClassroomAnswerInstruction = styled.div<ClassroomAnswerInstructionProps>`
  ${SubActivityInstruction} {
    max-width: ${rem(ACTIVITY_SHEET_CONTENT_MAX_WIDTH)};
    margin-bottom: ${({ $noMarginBottom }) =>
      $noMarginBottom ? 0 : rem(spacing24)};
  }

  ${SubActivityInstruction} p, ${SubActivityLabel} {
    font-size: ${rem(fontSize20)};
    line-height: ${rem(fontSize20LineHeight)};
    margin-bottom: 0;
    font-weight: ${fontWeightNormal};
    text-align: left !important;

    ${mediaUp.md`
      font-size: ${rem(fontSize30)};
      line-height: ${rem(fontSize30LineHeight)};
    `}
  }

  ${SubActivityInstruction} strong {
    font-weight: ${fontWeightNormal};
  }
`;

export const ClassroomAnswerControls = styled.div`
  background-color: ${grey1};
  margin-bottom: ${rem(spacing16)};
  padding: ${rem(spacing4)} 0;
  position: sticky;
  top: 0px;
  z-index: 1;
`;

export const ClassroomSuggestedAnswer = styled.div`
  position: relative;

  ${BadgeSmallStyled} {
    position: absolute;
    right: ${rem(spacing16)};
    top: -${rem(spacing12)};
  }

  ${ResponseFieldReadonly} {
    p,
    li {
      color: ${azure7};
    }
  }
`;

export const ClassroomAnswerGrid = styled(BoxList)`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${rem(spacing24)};

  ${mediaUp.sm`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${mediaUp.md`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${mediaUp.lg`
    grid-template-columns: repeat(4, 1fr);
  `}
`;

export const ClassroomAnswerGridItem = styled.li`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ClassroomAnswerGridButton = styled.button`
  background-color: transparent;
  border: none;
  border-radius: ${rem(borderRadius8)};
  padding: 0;
  position: absolute;
  inset: 0;
  z-index: 1;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    cursor: pointer;
  }

  ${standardFocusStateInset}
`;

export const ClassroomAnswerGridInner = styled.div`
  display: flex;
  justify-content: center;
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  flex-grow: 1;
  padding: ${rem(spacing24)};
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 12;
  overflow: hidden;

  & > div {
    margin: auto;
  }

  & + div {
    margin-top: ${rem(spacing12)};
  }
`;
